import { useIntl } from "react-intl";

import { passwordExpiredMessages } from "../messages";

export const usePasswordExpiredLabels = () => {
  const { formatMessage } = useIntl();

  return {
    cancelLabel: formatMessage(passwordExpiredMessages.cancel),
    confirmLabel: formatMessage(passwordExpiredMessages.confirm),
    description: formatMessage(passwordExpiredMessages.description),
    title: formatMessage(passwordExpiredMessages.title),
  };
};
